import React from 'react';
import PropTypes from 'prop-types';
import RefreshHeader from 'layoutComponents/RefreshHeader';
import EquipmentUtils from 'utils/EquipmentUtils';
const TechInventory = (props) => {

    const {inventory, isSelf, userId, getTechInventoryStarted} = props;

    const handleInventoryReload = (e) => {

        e.preventDefault();

        getTechInventoryStarted({
            isSelf: isSelf
        }, userId);
    };

    let techSections = [];

    if (inventory && inventory.get('details')) {

        const groupedByTechId = inventory
            .get('details')
            .groupBy((item) => {
                return item
                    .get('techId')
                    .trim();
            });

        groupedByTechId.forEach((techIdGroup, techIdGroupIndex) => {
            
            const groupedByBilling = techIdGroup.groupBy((item) => {
                return item.get('billingSystem');
            }).toList();

            const billingSections = [];

            groupedByBilling.forEach((billingGroup, billingGroupIndex) => {

                const groupedEquipment = billingGroup.groupBy((item) => {
                    return item
                        .get('serialNumber')
                        .trim();
                }).toList();

                const rows = [];

                groupedEquipment.forEach((item, index) => {
                    rows.push(
                        <tr key={'inventory_row_' + index}>
                            <td>
                                {item
                                    .first()
                                    .get('description')}
                            </td>
                            <td>
                                {item
                                    .first()
                                    .get('serialNumber')}
                            </td>
                            <td>
                                {EquipmentUtils.getEquipmentStatusDescription(item.first().get('status'))}
                            </td>
                        </tr>
                    );
                });

                const display = (
                    <div key={`tech_inventory_group_${techIdGroupIndex}_${billingGroupIndex}`}>
                        <h5 className="center-align">
                            Tech: {techIdGroup
                                .first()
                                .get('techId')}
                            &nbsp; Billing: {billingGroup
                                .first()
                                .get('billingSystem')}
                        </h5>
                        <table className="bordered striped wow-fst-equipment-table">
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <th>MAC Address</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows}
                            </tbody>
                        </table>
                        <br/>
                    </div>
                );

                billingSections.push(display);

            });

            techSections.push(billingSections);

        });

    }

    if (!techSections || techSections.length === 0) {
        techSections = (
            <h6 className="wow-fst-no-data-message">No Inventory to Display</h6>
        );
    }
    let loadedTime = null;

    if (inventory && inventory.get('loading')) {
        techSections = (
            <div className="wow-fst-loading-message">Loading Inventory...</div>
        );

        loadedTime = inventory.get('loadedTime');
    }

    return (
        <div>
            <RefreshHeader
                header="Inventory"
                loadedTime={loadedTime}
                onTouchTap={handleInventoryReload}/> {techSections}
        </div>
    );
};
TechInventory.propTypes = {
    inventory: PropTypes.object,
    userId: PropTypes.string,
    getTechInventoryStarted: PropTypes.func,
    isSelf: PropTypes.bool
};

export default TechInventory;


// WEBPACK FOOTER //
// ./src/components/equipment/TechInventory.js